import React, { useState } from "react";
import ViewButton from "./Buttons/ViewButton";
import ReviewButton from "./Buttons/ReviewButton";
import CheckWithDate from "./CheckWithDate";
import { format } from "date-fns";
import { Box, Modal } from "@mui/material";
import ViewReleaseOfInformation from "./forms/ViewReleaseOfInformation";
import ViewRevoke from "./forms/ViewRevoke";

function FormLineRoi(props) {
  const styleModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    height: "80%",
    borderRadius: 5,
    backgroundColor: "white",
    boxShadow: 24,
  };

  const styleModal2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    height: "auto",
    borderRadius: 5,
    backgroundColor: "white",
    boxShadow: 24,
  };

  const [showViewModal, setShowViewModal] = useState(false);
  const [showRevokeModal, setShowRevokeModal] = useState(false);

  const openViewModal = () => {
    setShowViewModal(true);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
  };

  const openRevokeModal = () => {
    setShowRevokeModal(true);
  };

  const closeRevokeModal = () => {
    setShowRevokeModal(false);
  };

  function formatDate(timestamp) {
    if (!timestamp || !timestamp.seconds) return "";

    const milliseconds =
      timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000;
    const date = new Date(milliseconds);

    if (isNaN(date)) return "";

    return format(date, "d MMMM yyyy");
  }

  return (
    <div
      // className={
      //   props.color === "1"
      //     ? "formLineMedium2 light-grey-form"
      //     : "formLineMedium2 grey-form"
      // }
      style={{
        marginLeft: "0px",
        display: "flex",
        flexDirection: "row",
        height: "50px",
        borderRadius: "30px",
        border: "1px solid lightgrey",
        width: "80%",
        marginTop: "5px",
        marginBottom: "5px",
        paddingLeft: "15px",
        paddingRight: "5px",
      }}
    >
      <Modal
        open={showViewModal}
        onClose={closeViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal}>
          <ViewReleaseOfInformation
            {...props}
            firstName={props.firstName}
            closemodal={closeViewModal}
          />
        </Box>
      </Modal>

      <Modal
        open={showRevokeModal}
        onClose={closeRevokeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal2}>
          <ViewRevoke
            documentId={props.documentId}
            subcollectionDocumentId={props.subcollectionDocumentId}
            {...props}
            firstName={props.firstName}
            closemodal={closeRevokeModal}
            clientId={props.clientId}
          />
        </Box>
      </Modal>

      <div className="formLineRoiBlock1">{props.title}</div>

      <div className="formLineRoiBlock2">{props.relationship}</div>

      <div className="formLineRoiBlock2bis">
        <CheckWithDate checked={true} content={formatDate(props.signedOn)} />
      </div>

      <div className="formLineRoiBlock2tris">
        <CheckWithDate
          title={props.revokedBy}
          checked={props.revoked}
          content={props.revoked ? formatDate(props.dateRevoked) : ""}
        />
      </div>

      <div className="formLineRoiBlock3">
        <ViewButton handleOpen={openViewModal} />
        {props.revoked ? "" : <ReviewButton handleOpen={openRevokeModal} />}
      </div>
    </div>
  );
}

export default FormLineRoi;
